import { useAtomValue } from 'jotai';

import { routinesSpotlightStepAtom } from '../spotlight/routinesSpotlightAtoms';

/** True while the Routines tour is on a step — ChatSidebar uses this to no-op close. */
export function useRoutinesSpotlightSidebarLock(): boolean {
  return useAtomValue(routinesSpotlightStepAtom) !== null;
}
